<template lang="pug">
Form(
  v-slot="$form"
  ref="formRef"
  :resolver="appForm.resolver"
  :initialValues="props.initialValues"
  @submit="submit"
  autocomplete="off"
)

  slot
  //- pre $form: {{ $form }}
  //- pre appForm: {{ appForm }}
</template>

<script setup>
import { ref, onMounted, provide } from 'vue'
import { useFormBuilder } from '@/use'
import { Form }  from '@primevue/forms'

const props = defineProps({
  formValidations: { type: Object, required: true },
  initialValues:   { type: Object, required: false, default: {} },
})

defineOptions({inheritAttrs: false})
const emit = defineEmits(['submit', 'onMounted'])

const formRef = ref()
const appForm = useFormBuilder(formRef, props.formValidations)

const submitted = ref(false)
provide('appFormSubmitted', submitted)

function submit(event) {
  submitted.value = true
  emit('submit', event)
}

onMounted(() => {
  emit('onMounted', { appForm: appForm })
})
</script>